export const CREATE_JOB_OPENING_INITIAL_VALUES = {
  postingTitle: "",
  department: "",
  hiringManager: "",
  assignedRecruiter: "",
  numberOfPosition: "",
  targetDate: "",
  openDate: "",
  jobStatus: "",
  jobType: "",
  industry: "",
  workExperience: "",
  salary: "",
  requiredSkills: "",
  city: "",
  state: "",
  country: "",
  zipCode: "",
  description: "",
  requirements: "",
  benefits: "",
  jobSummaryAttachment: "",
  attachments: "",
  title: "",
  sharedWithEmployees: false,
  preScreeningQuestions: "",
};


export const OFFER_INITIAL_VALUES = {
  // Tab 1 fields
  applicationId: '',
  candidateName: '',
  subject: '',

  // Tab 2 fields
  grossSalary: '',
  ctcSalary: '',
  currency: 'INR',
  frequency: 'annually',
  pf: false,
  salaryStructure: [
    { componentName: 'Basic Pay', percentage: 15 },
    { componentName: 'HRA', percentage: 11 },
    { componentName: 'Conveyance Allowance', percentage: 6 },
    { componentName: 'Medical Allowance', percentage: 4 },
    { componentName: 'Special Allowances', percentage: 2 },
    { componentName: 'Gross Earnings (A)', percentage: 2 },
    { componentName: 'EPF Employer Cont. (B)', percentage: 2 },
    { componentName: 'Graduity (D)', percentage: 15 },
    { componentName: 'CTC(A+B+C+D)', percentage: 11 },
    { componentName: 'EPF Deduction (G)', percentage: 6 },
    { componentName: 'Additional Cost', percentage: 4 },
    { componentName: 'Insurance Premium', percentage: 2 },
    { componentName: 'Take home salary (A-G)', percentage: 2 },
    { componentName: 'EPF Employer Cont.', percentage: 2 }
  ],
  // Tab 3 fields
  joiningDate: null,
  offerExpiryDate: null,
  offerLetterContent: '',
  templateId: ''
};
export const CANDIDATE_INITIAL_VALUES = {
  name: "",
  email: "",
  phone: "",
  currentCTC: "",
  lastWorkingDate: null,
  expectedCTC: "",
  city: "",
  state: "",
  experienceYears: "",
  experienceRange: "",
  highestQualification: "",
  currentJobTitle: "",
  currentEmployer: "",
  skills: [], // empty array for multiselect or tag input
  customSkill: "",
  status: "",
  source: "",
  owner: "",      // to be set from user context or dropdown
  resume: "",     // will typically hold a URL or file identifier
  coverLetter: "", // optional
};

export const REFERRAL_INITIAL_VALUES = {
  referringForJob: "",
  resume: "",
  name: "",
  email: "",
  phoneNumber: "",
  currentEmployer: "",
  experience: "",
  relationWithEmployee: "",
  referralFeedback: "",
};

export const INTERVIEW_INITIAL_VALUES = {
  application: "",
  interviewers: [],
  reason: '',
  round: "",
  department: "",
  interviewStatus: "",
  interviewerFeedback: "",
  interviewMode: "",
  interviewDate: null,
  startTime: null,
  endTime: null,
  commentForInterviewer: "",
};


export const APPLICATION_INITIAL_VALUES = {
  postingTitle: "",
  name: "",
  email: "",
  phone: "",
  city: "",
  experienceYears: "",
  state: "",
  noticePeriod: "",
  status: "",
  remarks: "",
  applicationSource: "",
  resume: "",
  coverLetter: "",
};
